import React from 'react'
import "./style.css"

const Privacy = () => {
  return (
    <div className='privacy_container'>
      <h2>Privacy Policy and Terms of Use</h2>

      <p><strong>1. Introduction</strong></p>
      <p>
        Welcome to NajoxGames.com! This Privacy Policy and Terms of Use govern your use of our website, NajoxGames.com, and any related services offered by NajoxGames.
      </p>
      <p>
        By using our website, you agree to the terms outlined in this policy. Please read this document carefully to understand how we collect, use, and protect your information.
      </p>
      <br />

      <p><strong>2. Data Collection</strong></p>
      <p>We don't collect any user information or data from users.</p>

      <p><strong>3. Use of Data</strong></p>
      <p>We collect and use your data for the following purposes:</p>
      <ul>
        <li>To provide and maintain our website.</li>
        <li>To manage your account and affiliate partner program participation.</li>
        <li>To communicate with you regarding your account, inquiries, and updates.</li>
        <li>To enhance our website's functionality and user experience.</li>
        <li>To comply with legal obligations.</li>
      </ul>
      <br /><br />

      <p><strong>4. Third-Party Services</strong></p>
      <p>
        While we do not allow third parties to access or process data directly, we may use third-party payment processors to facilitate transactions and payments on our website. Please review their respective privacy policies for more information.
      </p>
      <br />

      <p><strong>5. Children's Privacy</strong></p>
      <p>
        Our website is accessible to children; however, it is not designed or intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If you believe that a child has provided us with their personal information, please contact us, and we will promptly delete such information.
      </p>
      <br />

      <p><strong>6. Security Measures</strong></p>
      <p>
        We implement reasonable security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no data transmission over the internet or storage system can be guaranteed as 100% secure. Please take appropriate precautions when sharing your information online.
      </p>
      <br />

      <p><strong>8. Disclaimer</strong></p>
      <p>
        We do not collect or store any information related to gambling activities. This platform does not include any gambling content.
      </p>
      <p>
        All the games are for fun and entertainment purposes; we do not ask for any payment collection from the user's side.
        </p>
      <br />
    </div>
  )
}

export default Privacy
